export enum SoftwareVersion {
    ME0 = 'ME0',
    ME1 = 'ME1',
    ME2 = 'ME2',
    UNKNOWN = 'UNKNOWN'
}